import React, { useContext, useEffect } from "react";

import {
    usePhotoUploadWebSocket,
    usePhotoUploadsInDropzone,
    useFailedPhotoUploads
} from "./hooks";
import AllPhotoUploadsContext from "./context/AllPhotoUploadsContext";
import { useViewport } from "js/hooks/useViewport";

import breakpoints from "core/breakpoints";
import MobileError from "../Status/Mobile";

const InitializePhotoUploads = ({ children }) => {
    const { browserWidth } = useViewport();
    const isMobile = browserWidth < breakpoints.tablet.px;

    const AllPhotoUploadsContextValues = useContext(AllPhotoUploadsContext);

    const { fetchWithdrawnUploads } = AllPhotoUploadsContextValues;
    const { fetchFileCheckFailedUploads } = useFailedPhotoUploads();
    const { openConnection } = usePhotoUploadWebSocket();
    const {
        fetchUploads: fetchUploadsInDropzone
    } = usePhotoUploadsInDropzone();

    const initialize = () => {
        openConnection();
        fetchUploadsInDropzone();
        fetchFileCheckFailedUploads();
        fetchWithdrawnUploads();
    };

    useEffect(() => {
        initialize();
    }, []);

    return isMobile ? <MobileError /> : children;
};

export default InitializePhotoUploads;
